module.exports = "/_next/static/images/at-67c731e94301d0df10b90ac53a61fb34.svg";